import { render } from "./FeatureCard.vue?vue&type=template&id=51d86f38&scoped=true"
import script from "./FeatureCard.vue?vue&type=script&lang=js"
export * from "./FeatureCard.vue?vue&type=script&lang=js"

import "./FeatureCard.vue?vue&type=style&index=0&id=51d86f38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d86f38"]])

export default __exports__